import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=347a6d7d&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"
import style0 from "./tools.vue?vue&type=style&index=0&id=347a6d7d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a6d7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347a6d7d')) {
      api.createRecord('347a6d7d', component.options)
    } else {
      api.reload('347a6d7d', component.options)
    }
    module.hot.accept("./tools.vue?vue&type=template&id=347a6d7d&scoped=true", function () {
      api.rerender('347a6d7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/chat/tools.vue"
export default component.exports